<template>
    <div>
        <source-count-table
            title="Insufficient data to generate the requested estimate"
            note="The following are counts where both variables are not null."
            :columnHeadings="columnHeadings"
            :rows="rows"
            :rowAndColumnsTheSame="true"
        ></source-count-table>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', space-in-parens: 'off' */
import sourceCountTable from '@/components/sourceCountTable';
export default {
    props: ['selectionModel', 'reportModel', 'originalData'],
    components: {
        'source-count-table': sourceCountTable
    },
    created: function () {
        let vm = this;
        var independentColumnLabels = vm.selectionModel.v.independent.map(
            (v, i) => 'Independent ' + (i + 1)
        );
        vm.columnHeadings = ['Total', 'Intercept', ...independentColumnLabels];
        vm.rows = vm.originalData.variables.map((v, i) =>
            toRow(v, i, vm.originalData.results[i], vm.reportModel)
        );
    },
    data: function () {
        var vm = this;
        return {
            columnHeadings: [],
            rows: [],
            originalDatax: vm.originalData.results
        };
    },
    methods: {}
};

function convertCounts(counts, rowIndex) {
    return [
        counts[rowIndex],
        ...counts.map((c, i) => (i === rowIndex ? null : c))
    ];
}

function toRow(v, rowIndex, result, reportModel) {
    return {
        variable: v.definition.name,
        counts: convertCounts(result.matchingCounts, rowIndex),
        title: getTitle(v, rowIndex, result, reportModel),
        suffix: getSuffix(v, rowIndex, result, reportModel)
        // Modeling category: {{reportModel.dependentModelCategory}}
    };
}
function oldToRow(v, i, result, reportModel) {
    return {
        variable: v.definition.name,
        counts: result.matchingCounts,
        title: getTitle(v, i, result, reportModel),
        suffix: getSuffix(v, i, result, reportModel)
        // Modeling category: {{reportModel.dependentModelCategory}}
    };
}

function getTitle(v, i, result, reportModel) {
    if (i === 0)
        return (
            reportModel.parms.dependentVariable.variable.variableTitle +
            ', Modeling category: ' +
            reportModel.dependentModelCategory
        );
    else
        return reportModel.parms.independentVariables[i - 1].variable
            .variableTitle;
}

function getSuffix(v, i, result, reportModel) {
    if (i === 0) return 'Intercept';
    else return 'Independent ' + i;
}
</script>

<style scoped>
</style>
